export default {"src":"__ASTRO_ASSET_IMAGE__BVy8zFN4__","width":960,"height":540,"format":"jpg"}